module.exports = new __parcel__URL__("success.29c69069.wav").toString();